import { jsx as _jsx } from "react/jsx-runtime";
import { Box, TextAlpha } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
const ColorOutOfStockMessage = () => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    return (_jsx(Box, { paddingBlock: "2", children: _jsx(TextAlpha, { as: "span", strong: true, children: t('product.colorNotAvailable') }) }));
};
export default ColorOutOfStockMessage;
